import { lazy, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { sendGA4PageView } from '../../Shared/helper/google-analytics';

import OduComponent from '../pages/OduComponent';
import BroadbandRecharge from '../../features/orp/recharge/components/BroadbandRecharge/BroadbandRecharge';
import DataBundle from '../../features/orp/recharge/components/DataBundle/DataBundle';
import FixedRecharge from '../../features/orp/recharge/components/FixedRecharge/FixedRecharge';
import Postpaid from '../../features/orp/recharge/components/Postpaid';
import Prepaid from '../../features/orp/recharge/components/Prepaid/Prepaid';
import { AMB, BROADBAND_RECHARGE_ROUTE, BROADBAND_ROUTE, CHECK_ORDER_STATUS_ROUTE, DATA_CALCULATOR, DEFAULT_ROUTE, PAYMENT_NEW_ROUTE, PAYMENT_STATUS_ROUTE, PLANS_ROUTE, POSTPAID_ROUTE, PREPAID_ROUTE, RECHRGE_ROUTE, STAR_OIL, STORE_LOCATOR,BUY_BUNDLE_ROUTE } from './routeConstant';
import { useCurrentLocation } from '../Hooks/useCurrentLocation';

const Locator = lazy(() => import("../pages/Locator"))
const FTTX = lazy(() => import('../../FTTX/pages/FTTX'));
const PaymentPage = lazy(() => import('../../Payment/page'));
const PrepaidPage = lazy(() => import('../../FTTX/pages/Prepaid'));
const PostpaidPage = lazy(() => import('../../FTTX/pages/Postpaid'));
const StaticPageComponent = lazy(() => import('../pages/staticPage'));
const PaymentStatusPage = lazy(() => import('../pages/PaymentStatus'));
const PageNotFondComponent = lazy(() => import('../pages/pageNotFound'));
const DataCalculatorPage = lazy(() => import("../pages/DataCalculator"));
const HomePageComponent = lazy(() => import('../pages/HomePageComponent'));
const OrderStatusPage = lazy(() => import("../../FTTX/pages/OrderStatus"));
const PlansListPage = lazy(() => import('../../FTTX/pages/PlansListPage'));
const BusinessContactPage = lazy(() => import('../pages/BusinessComponent'));
const GetHelp = lazy(() => import('../../Shared/Components/GetHelp/GetHelp'));
const LandingPageLayout = lazy(() => import("../../FTTX/layout/LandingPageLayout"));
const NetworkCoverage = lazy(() => import('../../Shared/Components/NetworkCoverage/NetworkCoverage'));
const LeadStatusComponent = lazy(() => import('../../features/odu/components/LeadStatusComponent'));
const PaymentPageLayout = lazy(() => import('../../features/orp/payment/components/PaymentPageLayout'));
const FeedbackComponentLayOut = lazy(() => import("../../Shared/Components/Feedback/FeedbackComponent"));
const BroadbandRechargeHome = lazy(() => import('../../FTTX/features/Orp/features/BroadbandRechargeHome'));
const CorporatePostpaidComponent = lazy(() => import('../../Shared/Components/CorporatePostpaid/CorporatePostpaidComponent'));


const AppRoutes = () => {
  useCurrentLocation();


  useEffect(() => {
    sendGA4PageView();
  }, [window.location.pathname]);


  return (
    <Routes>
        <Route element={<LandingPageLayout />}>
          <Route path="/about" element={<StaticPageComponent />} />
          <Route path="/page-not-found" element={<PageNotFondComponent />} />
          <Route path="/openNetworks" element={<NetworkCoverage />} />
          <Route path="/gethelp" element={<GetHelp />} />
          <Route path="/prepaid-recharge" element={<Prepaid />} />
          <Route path="/postpaid-bill-pay" element={<Postpaid />} />
          <Route path="/data-bundle" element={<DataBundle />} />
          <Route path="/broadband-recharge" element={<BroadbandRecharge />} />
          <Route path="/orp/fixed-internet" element={<FixedRecharge />} />
          <Route path="/payment/*" element={<PaymentPageLayout />} />
          <Route path="/hbb-lead" element={<OduComponent />} />
          <Route path="/feedback-form" element={<FeedbackComponentLayOut />} />
          <Route path="/corporate-postpaid" element={<CorporatePostpaidComponent />} />
          <Route path="/hbb-lead-status" element={<LeadStatusComponent />} />
          <Route path="/business-form" element={<BusinessContactPage />} />
          <Route path={PAYMENT_STATUS_ROUTE} element={<PaymentStatusPage />} />
          <Route path={DEFAULT_ROUTE} element={<HomePageComponent />} />
          <Route path={BROADBAND_ROUTE} element={<FTTX />} />
          <Route path={PLANS_ROUTE} element={<PlansListPage />} />
          <Route path={PAYMENT_NEW_ROUTE} element={<PaymentPage />} />
          <Route path={PREPAID_ROUTE} element={<PrepaidPage />} />
          <Route path={POSTPAID_ROUTE} element={<PostpaidPage />} />
          <Route path={BUY_BUNDLE_ROUTE} element={<PrepaidPage />} />
          <Route path={DATA_CALCULATOR} element={<DataCalculatorPage />} />
          <Route path={BROADBAND_RECHARGE_ROUTE} element={<BroadbandRechargeHome />} />
          <Route path={STORE_LOCATOR} element={<Locator />} />
          <Route path={STAR_OIL} element={<Locator />} />
          <Route path={AMB} element={<Locator />} />
          <Route path={CHECK_ORDER_STATUS_ROUTE} element={<OrderStatusPage />} />
          <Route path="*" element={<StaticPageComponent />} />
        </Route>
    </Routes>
  );
}

export default AppRoutes;